import gql from 'graphql-tag';

import client from '../graphqlAPI';

// One page of radio programs or episodes (kind: 'programs' | 'episodes'), plus every
// program for the filter and the episode form's parent select. ps-back: types/admin/RadioAdmin.js.
const GET_RADIO_SHOWS_LIST = gql`
  query getRadioShowsList($kind: String!, $search: String, $channel: Int, $parent: Int, $status: String, $limit: Int, $offset: Int, $sortField: String, $sortOrder: Int) {
    getRadioShowsList(kind: $kind, search: $search, channel: $channel, parent: $parent, status: $status, limit: $limit, offset: $offset, sortField: $sortField, sortOrder: $sortOrder) {
      isAuth
      total
      programs { id slug title { es ca en pt } status }
      shows {
        _id
        id
        parent
        parentSlug
        parentTitle { es ca en pt }
        slug
        title { es ca en pt }
        status
        highlight
        channel
        firstAirDate
        nextAirDate
        episodeCount
        createdAt
        updatedAt
      }
    }
  }
`;

const getRadioShowsList = async ({
  kind, search, channel, parent, status, limit, offset, sortField, sortOrder,
} = {}) => {
  try {
    const result = await client
      .query({
        query: GET_RADIO_SHOWS_LIST,
        errorPolicy: 'all',
        variables: { kind, search, channel, parent, status, limit, offset, sortField, sortOrder },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getRadioShowsList: getRadioShowsListData },
    } = result;

    if (getRadioShowsListData) {
      return getRadioShowsListData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getRadioShowsList = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getRadioShowsList Error: ${error}`);
    return null;
  }
};

export default getRadioShowsList;
